import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { BrowserRouter } from "react-router-dom";

import reportWebVitals from "./reportWebVitals";
import { HelmetProvider } from "react-helmet-async";
import { SidebarProvider } from "./Context/SidebarContext";
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import { GoogleOAuthProvider } from "@react-oauth/google";
import './i18n/config';

// NOTE: NotificationProvider is mounted once inside App.tsx (within ThemeProvider). It used to be
// mounted here too, which opened a second, unused SignalR connection — removed to avoid duplicates.

const GOOGLE_CLIENT_ID = "1053304443790-66970um24v2pglkogicqpoocq0nqetn2.apps.googleusercontent.com";

// Lazy route chunks: if a NEW deploy changed chunk hashes while a user had a stale index.html/tab
// open, a chunk fetch can 404 (ChunkLoadError). Reload ONCE to pick up the fresh asset manifest
// instead of showing a broken page. sessionStorage guard prevents an infinite reload loop; it is
// cleared shortly after a successful load so a later in-session navigation can also self-heal once.
const CHUNK_RELOAD_KEY = 'chunk-reload-attempt';
const isChunkError = (msg?: string) =>
  !!msg && (/Loading (?:CSS )?chunk [\w-]+ failed/i.test(msg) || /ChunkLoadError/i.test(msg) || /error loading dynamically imported module/i.test(msg));
const reloadOnceForChunkError = (msg?: string) => {
  if (isChunkError(msg) && !sessionStorage.getItem(CHUNK_RELOAD_KEY)) {
    sessionStorage.setItem(CHUNK_RELOAD_KEY, '1');
    window.location.reload();
  }
};
window.addEventListener('error', (e) => reloadOnceForChunkError(e?.message));
window.addEventListener('unhandledrejection', (e) => reloadOnceForChunkError(e?.reason?.message || String(e?.reason || '')));
window.addEventListener('load', () => setTimeout(() => sessionStorage.removeItem(CHUNK_RELOAD_KEY), 5000));

const root = ReactDOM.createRoot(document.getElementById("root")!);

root.render(
  // <React.StrictMode>
  <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
    <HelmetProvider>
      <BrowserRouter>
        <SidebarProvider>
          <App />
        </SidebarProvider>
      </BrowserRouter>
    </HelmetProvider>
  </GoogleOAuthProvider>
  // </React.StrictMode>

);

// Service worker: updates notify via SW_UPDATE_AVAILABLE_EVENT (see App splash listener).
// Do not force reload here — avoids clearing session UX on dashboard after each deploy.
serviceWorkerRegistration.register();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();


